var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"thankwrapper"},[_c('div',[_c('h2',[_vm._v("Danke für ihre Buchung, wir werden uns bei ihnen melden!")])])])
}]

export { render, staticRenderFns }